import { render, staticRenderFns } from "./AddSubdivision.vue?vue&type=template&id=acff3fb4&"
import script from "./AddSubdivision.vue?vue&type=script&lang=ts&"
export * from "./AddSubdivision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports